import React from 'react'
import { RecommendGenreCard } from './GenreCard'

type Props = {
  image: {
    src: string
    alt: string
    width: number
    height: number
  }
  text: string
}[]

export const RecommendGenreCards = (props: Props): JSX.Element => {
  return (
    <div className="flex flex-row flex-wrap justify-between w-[87.2vw] lg:w-[62.6vw]">
      {Object.values(props).map((item, i) => (
        <RecommendGenreCard key={i} {...item} />
      ))}
    </div>
  )
}
